<template>
  <div>
    <vs-prompt title="Confirm venue guests anonymization" color="danger" @cancel="cancel" @accept="accept"
      :active.sync="prompt" accept-text="Confirm Deletion" :is-valid="validForm">

      <!-- A confirmation text plus an input field where they must enter the venues exact name in order to delete it -->

      <vs-row>
        <vs-col vs-w="12">
          <p>
            Are you sure you want to permanently anonymize all guests for this venue <strong>{{ generalInfo.name
              }}</strong>?
            <br />
            This action may take some time to complete and <b>cannot be undone</b>. You may close this browser window
            while waiting for the action to complete.
          </p>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4 justify-center flex">
        <vs-col vs-w="12">
          <vs-input v-model="venueNameInput" class="w-full" label="Enter exact venue name to proceed" />
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      moment,

      prompt: false,
      venueNameInput: "",
    };
  },
  props: {
  },
  emits: ["onConfirmed", "onCancelled"],
  computed: {
    ...mapGetters({
      generalInfo: "venues/generalInfo",
    }),
    validForm() {
      return this.venueNameInput === this.generalInfo.name;
    },

  },
  methods: {
    async show() {
      // dispatch eligible products
      this.prompt = true;
    },
    async accept() {
      this.$emit("onConfirmed");
    },
    cancel() {
      this.$emit("onCancelled");

    }
  },
};
</script>
